import { defineComponent as _defineComponent } from 'vue'
import { CtInventoryLocation, CtProduct, CtStockItem, CtStorageLocation } from '@/models/interfaces/content-type'
import { UUID } from '@Protium/vue-ozone-utils'
import { computed, onMounted, onUnmounted, ref, watch } from 'vue'
import { useRouter } from 'vue-router'
import useInputListener from '@/composables/useInputListener'
import { useStore } from 'vuex'
import { useQuasar } from 'quasar'
import { Entry } from '@/models/generics'
import { ContentType } from '@/services/directr'
import { isUUID } from '@/utils'


export default /*@__PURE__*/_defineComponent({
  __name: 'ProductSearchModal',
  emits: ["update:show", "navigate", "input"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

const $q = useQuasar()
const $store = useStore()
const $router = useRouter()
const $directr = $store.getters['Services/Directr']

// const props = withDefaults(defineProps<{}>(), {})

const scannedInput = ref<string>()
const scannerListener = useInputListener(scannedInput)

scannerListener.enable()

onUnmounted(() => scannerListener.listener.destroy())
onMounted(() => scannerListener.listener.create())

const showModal = ref(false)

const scannedResult = ref<Array<CtProduct | CtStockItem>>()
const relatedLocations = ref<Array<CtInventoryLocation>>()

watch(() => scannedInput.value, handleScannedInput)
watch(() => showModal.value, (val) => {
  if (!val) scannedResult.value = []
})

async function handleScannedInput (value) {
  if (!value) return

  // query order.fulfillment for a matching shipment-id, or a bag-id...
  scannedInput.value = ''
  const items = await $directr.product.searchIdentifier(value)

  // push to list...
  if (items?.length) {
    scannedResult.value = items
    showModal.value = true

    // lazily search for related locations...
    scannerListener.updateNotification(value, null, true)
    const stockitemIds = scannedResult.value?.flatMap(p => (p as CtProduct).components?.map(c => isUUID(c) ? c : c?.sys?.id).concat(p.sys.id))
      .filter(f => Boolean(f) && isUUID(f))

    if (stockitemIds?.length) {
      const { items: locations } = await $directr.get(ContentType.InventoryLocation, stockitemIds.map(sid => ({ field: 'stock_item', method: 'is', match: sid, type: 'uuid' })), { query: { any: true }, resolve: 1 })

      relatedLocations.value = locations

    } else {
      relatedLocations.value = []
    }

  } else {
    // search for locations instead...
    scannerListener.updateNotification(value, null, true)

    const { items: locations } = await $directr.get(ContentType.InventoryLocation,
      [
        { field: 'sys.id', method: 'is', match: value },
        { field: 'id', method: 'is', match: value.toLowerCase() },
        { field: 'name', method: 'is', match: value.toLowerCase() }
      ], { query: { any: true }, resolve: 1 })

    if (locations?.length) {
      scannedResult.value = locations.map(l => l.stock_item)
      showModal.value = true
    }
    relatedLocations.value = locations
  }
  scannerListener.updateNotification(value, null, false)
}

const emit = __emit

const hiddenScanInput = ref<string>()
function navigateToProduct (item: CtProduct) {
  if (item?.sys?.type !== 'product') return
  const sysId = item?.sys?.id
  if (!sysId) return

  showModal.value = false
  // console.warn('hidden input', hiddenScanInput.value, scannedInput.value)
  if (hiddenScanInput.value?.length &&
    !(
      String(hiddenScanInput.value).trim().toLowerCase() === String(item.sku).trim().toLowerCase() ||
      (item.ean?.length && item.ean.some(e => String(e).trim().toLowerCase() === String(hiddenScanInput.value).trim().toLowerCase()))
    )) {
    emit('input', hiddenScanInput.value)
    console.warn('new input', hiddenScanInput.value, scannedInput.value)
    scannedInput.value = hiddenScanInput.value
    hiddenScanInput.value = ''
    return
  }

  if (!sysId) {
    console.warn('no sys id', item)
    return
  }

  void $router.push({ name: 'ProductDetailIndex', params: { productId: sysId, s: 'barcode', editing: '' } })
}

function navigateToLocation (loc: CtInventoryLocation<any,any,any,CtStorageLocation>) {
  const id = loc?.sys?.id
  if (!id) return
  void $router.push({ name: 'ManageInventoryOverview', params: { location: id, storage_location: loc.storage_location?.sys?.id, s: 'barcode', editing: '' } })
}


const __returned__ = { $q, $store, $router, $directr, scannedInput, scannerListener, showModal, scannedResult, relatedLocations, handleScannedInput, emit, hiddenScanInput, navigateToProduct, navigateToLocation, get CtInventoryLocation() { return CtInventoryLocation }, get CtProduct() { return CtProduct }, get CtStockItem() { return CtStockItem }, get CtStorageLocation() { return CtStorageLocation }, get UUID() { return UUID }, computed, onMounted, onUnmounted, ref, watch, get useRouter() { return useRouter }, get useInputListener() { return useInputListener }, get useStore() { return useStore }, get useQuasar() { return useQuasar }, get Entry() { return Entry }, get ContentType() { return ContentType }, get isUUID() { return isUUID } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})